{
  "eyebrow": "Confirmă-ți planul",
  "title": "Verifică și configurează.",
  "sub": "Poți schimba ciclul de facturare sau planul oricând din panoul de administrare.",
  "yourPlan": "Planul tău",
  "changePlan": "Schimbă planul",
  "billing": "Ciclu de facturare",
  "billingMonthLabel": "Plată lunară",
  "billingMonthDesc": "Flexibil. Anulează oricând.",
  "billingYearLabel": "Plată anuală",
  "billingYearDesc": "~17% reducere. Facturat o dată pe an.",
  "addons": "Add-on-uri",
  "addon": {
    "ssec": "Asigurări sociale (check-in/out@work)",
    "ssecDesc": "Doar Belgia — declarație Dimona automată.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "GPS live pentru vehiculele companiei. +4 €/vehicul/lună.",
    "vehicles": "Vehicule",
    "projectAddon": "Add-on management de proiect",
    "projectAddonDesc": "Deblochează funcționalitățile de management de proiect din Time Pro (lucrări suplimentare, planificare, gestionare subcontractanți)."
  },
  "employees": {
    "title": "Câți angajați?",
    "active": "utilizatori activi",
    "popular": "Majoritatea echipelor aleg {{n}}"
  },
  "estimate": "Cost lunar estimat",
  "estimateNote": "Fără TVA. Tarifele per utilizator se calculează pe baza angajaților activi.",
  "estimateUnavailable": "Catalog de prețuri indisponibil. Reîncearcă pentru a încărca cele mai noi prețuri."
}
